import { useState } from 'react';
import Accordion from './Accordion';
import {
  OrderItemsPatientViewProps,
  PrescriptionStatus,
} from '../interface/interface';
import CustomModal from './CustomModal';

const AccordionContainer = (props: OrderItemsPatientViewProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [imageUrl, setImageUrl] = useState<string>('');

  const handleToggle = (index: number) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  const renderPrescriptionStatus = (status: string | undefined) => {
    switch (status) {
      case PrescriptionStatus.Active:
        return (
          <span className="w-2.5 h-2.5 bg-secondary-green-600 mr-2 rounded-full"></span>
        );
      case PrescriptionStatus.Expired:
        return (
          <span className="w-2.5 h-2.5 bg-secondary-orange-600 mr-2 rounded-full"></span>
        );
      case PrescriptionStatus.Completed:
        return (
          <span className="w-2.5 h-2.5 bg-secondary-slate-600 mr-2 rounded-full"></span>
        );
      case PrescriptionStatus.Cancelled:
      case PrescriptionStatus.Ceased:
        return (
          <span className="w-2.5 h-2.5 bg-secondary-red-600 mr-2 rounded-full"></span>
        );
      default:
        return '-';
    }
  };

  return (
    <>
      {props?.data?.map((orderProduct, index) => (
        <Accordion
          key={index}
          title={
            <div className="flex">
              <img
                className="w-16 h-20 mr-5 cursor-pointer"
                src={orderProduct.imgUrl ?? '/default-image.png'}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(true);
                  setImageUrl(orderProduct.imgUrl ?? '/default-image.png');
                }}
              />
              <div className="ml-3">
                <p className="text-sm text-primary-blue-500 font-bold break-words whitespace-normal flex-1 pr-4">
                  {orderProduct.productName}
                </p>
                <p className="text-xs text-primary-blue-500 font-regular mt-1.5">
                  Ordered Qty: <span>{orderProduct.orderedQty}</span>
                </p>
                <p className="mt-5 text-sm text-primary-blue-500 font-semibold flex items-center">
                  <span>{orderProduct.price}</span>
                </p>
              </div>
            </div>
          }
          isOpen={openIndex === index}
          onAccordionToggle={() => handleToggle(index)}
        >
          <ul>
            <li className="rounded-md bg-secondary-cornflowerblue-50 p-4 flex justify-between items-center mb-2">
              <p className="text-sm text-primary-blue-500 font-semibold">
                Prescription Status
              </p>
              <p className="text-sm text-primary-blue-500 font-semibold flex items-center">
                {renderPrescriptionStatus(orderProduct?.prescriptionStatus)}
              </p>
            </li>
            <li className="rounded-md bg-secondary-cornflowerblue-50 p-4 flex justify-between items-center mb-2">
              <p className="text-sm text-primary-blue-500 font-semibold">
                Repeats Remaining
              </p>
              <p className="text-sm text-primary-blue-500 font-regular flex items-center">
                {orderProduct?.remainingRepeats ?? '-'}
              </p>
            </li>
            <li className="rounded-md bg-secondary-cornflowerblue-50 p-4 flex justify-between items-center mb-2">
              <p className="text-sm text-primary-blue-500 font-semibold">
                Used Monthly Limit
              </p>
              <p className="text-sm text-primary-blue-500 font-regular flex items-center">
                {orderProduct.monthlyLimit}
              </p>
            </li>
          </ul>
        </Accordion>
      ))}

      <CustomModal
        isOpen={open}
        onClose={() => setOpen(false)}
        header=""
        footer=""
        modalSize="w-auto h-auto"
      >
        <img className="w-auto h-auto" src={imageUrl} />
      </CustomModal>
    </>
  );
};

export default AccordionContainer;
